var _rect, _path, _path2, _path3, _path4, _path5, _path6, _g, _circle, _path7, _circle2, _circle3, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKpiTeaser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    viewBox: "0 0 320 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 152,
    transform: "translate(8 8)",
    fill: "#A5B0B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85 27H218V125H85V27Z",
    fill: "#4C6170",
    stroke: "white",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152 27H218V76H152V27Z",
    fill: "#798894",
    stroke: "white",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130 76H173V125H130V76Z",
    fill: "#F1F2F4",
    stroke: "white",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M173 76H218V125H173V76Z",
    fill: "#D2D7DB",
    stroke: "white",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85 76H130V125H85V76Z",
    fill: "#798894",
    stroke: "white",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M182.453 92.052L177.931 91.0002L180.273 95.0088L203 133.916L204.51 136.5L206.32 134.116L213.116 125.168L230.088 137.613L231.674 138.776L232.863 137.21L238.593 129.666L239.823 128.046L238.183 126.844L221.265 114.439L228.021 105.545L229.888 103.086L226.881 102.387L182.453 92.052Z",
    fill: "white",
    stroke: "#4C6170",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5255_87293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.185 67.5688H137.57V69.0002H139.185V67.5688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.398 67.5688H126.768V69.0002H128.398V67.5688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.546 39.5217H133.686V37.6881H133.718L134.636 35.0762H133.971L133.258 37.0978H132.731L132.018 35.0762H131.385L132.309 37.6881H132.335V39.5217H125.475L123.021 42.7553V65.0351L125.448 67.25H140.525L143 65.0351V43.0374L140.546 39.5217ZM124.963 57.6329L123.691 57.1418V46.2866L124.963 45.2418V57.6329ZM126.018 40.4359H139.955V43.7896H126.055L126.018 40.4359ZM126.018 44.7351H139.955V57.6329H126.055L126.018 44.7351ZM128.805 60.4538H126.91C126.646 60.4538 126.392 60.3498 126.205 60.1646C126.018 59.9794 125.913 59.7283 125.913 59.4665C125.913 59.2046 126.018 58.9535 126.205 58.7683C126.392 58.5832 126.646 58.4792 126.91 58.4792H128.831C129.096 58.4792 129.349 58.5832 129.536 58.7683C129.723 58.9535 129.828 59.2046 129.828 59.4665C129.828 59.7283 129.723 59.9794 129.536 60.1646C129.349 60.3498 129.096 60.4538 128.831 60.4538H128.805ZM139.063 60.4538H137.169C136.904 60.4538 136.651 60.3498 136.464 60.1646C136.276 59.9794 136.171 59.7283 136.171 59.4665C136.171 59.2046 136.276 58.9535 136.464 58.7683C136.651 58.5832 136.904 58.4792 137.169 58.4792H139.09C139.354 58.4792 139.608 58.5832 139.795 58.7683C139.982 58.9535 140.087 59.2046 140.087 59.4665C140.087 59.7283 139.982 59.9794 139.795 60.1646C139.608 60.3498 139.354 60.4538 139.09 60.4538H139.063ZM142.282 57.1418L141.005 57.6329V45.2314L142.282 46.2762V57.1418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.106 35.4888L137.248 34.8776H128.747L126.894 35.4888L126.615 34.6582L128.678 34L137.464 34.0209L139.385 34.6582L139.106 35.4888Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 151.875,
    cy: 99.875,
    r: 14.875,
    fill: "#4C6170"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M158.717 105.722C150.484 112.453 144.916 105.322 144.916 105.322C144.916 105.322 146.74 107.47 151.989 107.47C155.792 107.47 157.864 106.343 158.717 105.722C158.874 105.594 159.032 105.46 159.19 105.322C159.19 105.322 159.042 105.485 158.717 105.722Z",
    fill: "#F1F2F4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.517,
    cy: 96.6512,
    r: 2.22347,
    fill: "#F1F2F4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.634,
    cy: 96.6512,
    r: 2.22347,
    fill: "#F1F2F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 151,
    width: 304,
    height: 9,
    fill: "#FFB60A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5255_87293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 35,
    fill: "white",
    transform: "translate(123 34)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiTeaser);
export default __webpack_public_path__ + "static/media/kpi_teaser.2a2f167a82099ca39e70c9d80f03fe07.svg";
export { ForwardRef as ReactComponent };